import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loading from '../../components/loading/Loading';
import Timeline from '../../components/timeline/Timeline';
import { ACTIVITY_TYPES } from '../../constants/activity';
import {
  PRODUCT_TYPE,
  SMART_SELECTION_DELIVERY_METHOD,
} from '../../constants/product';
import { listProjectActivities } from '../../redux/actions';
import { generateDefaultActivity } from '../../utilities/activity';
import { isStaff } from '../../utilities/user';
import JobActivity from './JobActivity';
import { partitionBy } from '@larki/shared/object';
// import { useGetProjectQuery } from '../../redux/rtk';

const JobTimeline = () => {
  const dispatch = useDispatch();
  // TODO: confusing, projectId vs currentProject?
  const { projects, currentUser, currentProject, isStaffActivityListVisible } =
    useSelector((state) => ({
      projects: state.activity.projects,
      isStaffActivityListVisible: state.activity.isStaffActivityListVisible,
      currentUser: state.profileReducer.userProfile,
      currentProject: state.project.currentProject,
    }));
  const { projectId } = useParams();
  // const currentProject = useGetProjectQuery({projectId, params: {includeJobs: true}});

  const isLoading = useMemo(
    () => projects[projectId]?.ui?.isLoading,
    [projectId, projects]
  );

  const fetchProjectActivities = useCallback(() => {
    if (projectId) {
      dispatch(listProjectActivities(projectId));
    }
  }, [dispatch, projectId]);

  useEffect(() => {
    fetchProjectActivities();
  }, [fetchProjectActivities]);

  /**
   * Duplicate an order that has metadata && metadata.action === quote
   * Bcoz, RFQ Activity is not created and save, only one activity type="order" and title "Order received".
   *
   * TODO: this is wrong, it uses the job's current quote rather than the one saved at the time
   */
  const projectActivities = useMemo(() => {
    if (projects[projectId]?.activities) {
      const activities = [...(projects[projectId]?.activities ?? [])];
      if (currentProject.jobs && activities) {
        return activities.flatMap((activity) => {
          const { type, metadata } = activity;
          if (
            type === ACTIVITY_TYPES.order &&
            !isEmpty(metadata) &&
            metadata.action === 'quote'
          ) {
            const [rfqCharges, quoteCharges] = partitionBy(
              activity.metadata?.quote_data?.charges ?? [],
              (charge) =>
                charge.type === 'data' &&
                [
                  PRODUCT_TYPE.UNKNOWN,
                  SMART_SELECTION_DELIVERY_METHOD.MANUAL,
                ].includes(charge.details.delivery_method)
            );
            const toAdd = [];
            if (rfqCharges.length > 0) {
              toAdd.push({ ...activity, rfqCharges });
            }
            if (quoteCharges.length > 0) {
              toAdd.push({ ...activity, quoteCharges });
            }
            return toAdd;
          }
          return [activity];
        });
      }
    }
    return [];
  }, [currentProject.jobs, projectId, projects]);

  const rawActivities = projectActivities?.sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  const activities = isEmpty(rawActivities)
    ? [generateDefaultActivity()]
    : filter(rawActivities, (activity) =>
        !isStaffActivityListVisible ? !isStaff(activity?.visibility) : true
      );

  // TODO: refactor job to project timeline and activity
  return (
    <Timeline className='JobTimeline'>
      {isLoading ? (
        <Loading />
      ) : (
        activities &&
        activities.map((activity, i) => (
          <JobActivity
            key={i}
            currentProject={currentProject}
            jobActivity={activity}
            currentUser={currentUser}
          />
        ))
      )}
    </Timeline>
  );
};

export default JobTimeline;
